<template>
  <div class="c-material-datepicker">
    <Input
      :value="formattedValue"
      :label="$t('Data di Nascita')"
      labelColor="#8a8497"
      primary
      @onFocus="onFocus"
      @onClick="onClick"
      disabled
    >
      <template slot="icon">
        <i @click="onClick" class="far fa-calendar "></i>
      </template>
    </Input>
    <div class="c-material-datepicker__picker" @click.stop v-if="isShowed">
      <picker @input="onDate" :value="pickerValue" is-inline> </picker>
    </div>
  </div>
</template>

<script>
import Input from "../common/Inputs/Input";
import picker from "v-calendar/lib/components/date-picker.umd";
export default {
  name: "Datepicker",
  components: {
    Input,
    picker
  },
  props: {
    value: {
      type: String,
      required: true
    },
    swiper: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isShowed: false,
      init: false
    };
  },
  computed: {
    formattedValue() {
      const date = this.moment(this.value, "DD/MM/YYYY");
      if (date.isValid()) {
        return this.moment(this.value, "DD/MM/YYYY").format("DD/MM/YYYY");
      }
      return this.$i18n.t("Inserisci data");
    },
    pickerValue() {
      const date = this.moment(this.value, "DD/MM/YYYY");
      if (date.isValid()) {
        return this.moment(this.value, "DD/MM/YYYY").toDate();
      }
      return " ";
    }
  },
  methods: {
    onFocus(focus) {
      this.show = focus;
    },
    globalClick() {
      this.onClick();
    },
    onDate(date) {
      if (this.init) {
        this.onClick();
      }
      this.init = true;
      this.$emit("input", this.moment(date).format("DD/MM/YYYY"));
    },
    onClick() {
      if (!this.swiper) {
        return;
      }
      this.isShowed = !this.isShowed;
      const cmp = document.querySelector(".c-profile-view");
      const swiper = cmp.querySelector(".swiper-container");
      if (!this.isShowed) {
        setTimeout(() => {
          cmp.classList.remove("overflow-hidden");
          swiper.style.overflow = "hidden";
          this.init = false;
          document.removeEventListener("click", this.globalClick);
        }, 100);
      } else {
        setTimeout(() => {
          cmp.classList.add("overflow-hidden");
          swiper.style.overflow = "visible";
          document.addEventListener("click", this.globalClick);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-material-datepicker {
  position: relative;
  ::v-deep .c-input__input {
    cursor: pointer !important;
  }
}
.c-material-datepicker__picker {
  position: absolute;
  bottom: 35px;
  left: 120px;
  z-index: 10;
}
</style>
